import React from 'react';

import classNames from 'classnames';

import cls from './Form.module.css';

interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {
    children: React.ReactNode;
    classes?: string;
}

export const Form = ({ children, classes, ...props }: FormProps) => (
    <form className={classNames(cls.Form, [classes])} {...props}>
        {children}
    </form>
);
